import React from 'react';

import iconFacebook from '../images/footer/ic_facebook.svg'
import iconTwitter from '../images/footer/ic_twitter.svg'
import iconIG from '../images/footer/ic_ig.svg'
import iconGmail from '../images/footer/ic_gmail.svg'
import iconTel from '../images/footer/ic_tel.svg'
import iconYoutube from '../images/footer/ic_youtube.svg'

import logoDBD from '../images/footer/logo_DBD.svg'
import logoNSI from '../images/footer/logo_NSI.svg'
import logoRP from '../images/footer/logo_RP.svg'

function Footer() {
  
  return (
  <div className="w-full flex flex-wrap font-prompt bg-grey-900">
    <div className='flex flex-wrap w-full   py-10 pl-4 md:pl-12 pr-4 md:pr-12 text-white lg:w-1092 lg:pl-0 lg:mx-auto'>
      
      <div className='w-full md:w-1/2 lg:w-1/3 pr-0 md:pr-6'>

        <label className='flex text-base w-full'>บริษัท ประกันภัยไทยวิวัฒน์ จำกัด (มหาชน)</label>
        <label className='flex text-base text-grey-800  mt-1'>71 ถนนดินแดง แขวงสามเสนใน เขตพญาไท กรุงเทพฯ 10400</label>

        <label className='flex text-base w-full mt-6'>ใบอนุญาตเลขที่</label>
        <label className='flex text-base text-grey-800  mt-1'>8/2516</label>

      </div>

      <div className='flex flex-wrap w-full md:w-1/2'> 
        <div className='w-full md:w-full lg:w-1/2 pl-0 md:pl-6'>
          <label className='flex text-base w-full  mt-6 md:mt-0 '>ติดต่อเรา</label>
          <div className='flex w-full mt-1'>
            <div className='bg-grey-800 py-2 px-2 rounded-md mr-2'>
              <a href='https://www.facebook.com/thaivivat' target={'_blank'}><img src={iconFacebook} alt="link_facebook" /></a>
            </div>
            <div className='bg-grey-800 py-2 px-2 rounded-md mr-2'>
              <a href='https://twitter.com/thaivivat' target={'_blank'}><img src={iconTwitter}  alt="link_twitter"  /></a>
            </div>
            <div className='bg-grey-800 py-2 px-2 rounded-md mr-2'>
              <a href='https://www.instagram.com/thaivivat.insurance' target={'_blank'}><img src={iconIG}  alt="link_ig"  /></a>
            </div>
            <div className='bg-grey-800 py-2 px-2 rounded-md mr-2'>
              <a href="mailto:info@thaivivat.co.th" target={'_blank'}><img src={iconGmail}  alt="link_gmail"  /></a>
            </div>
            <div className='bg-grey-800 py-2 px-2 rounded-md mr-2'>
              <a href="tel:1231" target={'_blank'}><img src={iconTel}  alt="link_tel"  /></a>
            </div>
            <div className='bg-grey-800 py-2 px-2 rounded-md mr-2'>
              <a href='https://www.youtube.com/c/ThaivivatInsurance' target={'_blank'}><img src={iconYoutube}  alt="link_youtube"  /></a>
            </div>
          </div>
        </div>

        <div className='w-full md:w-full lg:w-1/2  pl-0 md:pl-6'>
          <label className='flex text-base w-full mt-6 lg:mt-0'>มาตรฐานการรับรอง</label>
          <div className='flex w-full  mt-1'>
            <div className='bg-white py-2 px-2 rounded-md mr-2'>
              <img src={logoDBD} alt="facebook thaivivat" />
            </div>
            <div className='bg-white py-2 px-2 rounded-md mr-2'>
              <img src={logoNSI} alt="facebook thaivivat" />
            </div>
            <div className='bg-white py-2 px-2 rounded-md mr-2'>
              <img src={logoRP} alt="facebook thaivivat" />
            </div>
          </div>
        </div>
      </div>

    </div>

    <div className='flex flex-wrap w-full bg-black  py-4 pl-4 md:pl-12 pr-4 md:pr-12 text-white'>
      <label className='flex text-base text-white align-middle justify-center w-full'>ดำเนินการโดย บริษัท พรีเมียม ไดเร็ค โบรกเกอร์ จำกัด  |
@2020 บริษัท ประกันภัยไทยวิวัฒน์ จำกัด (มหาชน) สงวนลิขสิทธิ์</label>
    </div>    

  </div>
  )
}

export default Footer;